/**
 * Safely parses an HTML string containing <ul><li> items and returns an array of text strings.
 * Also handles plain text with \r\n or \n line breaks as bullet points.
 */
export function parseBulletPoints(htmlString: string): string[] {
  if (!htmlString) return []

  // First, try to extract content between <li> and </li> tags
  const liRegex = /<li[^>]*>(.*?)<\/li>/gi
  const matches: string[] = []
  let match

  while ((match = liRegex.exec(htmlString)) !== null) {
    // Remove any nested HTML tags from the matched content
    const cleanText = match[1].replace(/<[^>]*>?/gm, '').trim()
    if (cleanText) {
      matches.push(cleanText)
    }
  }

  // If no <li> tags found, fall back to splitting by newlines
  if (matches.length === 0) {
    const lines = htmlString
      .replace(/<[^>]*>?/gm, '') // Strip any HTML tags
      .split(/\r?\n/)
      .map((line) => line.trim())
      .filter((line) => line.length > 0)

    return lines
  }

  return matches
}
